import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import HandwerkBento from "./HandwerkBento";
import pvDachAsset from "@/assets/pv-dach-einfamilienhaus.png";
import stromspeicherAsset from "@/assets/einfamilienhaus-strom-speichern.png";
import eAutoLadenAsset from "@/assets/einfamilienhaus-e-auto-laden.png";
import smartHomeAsset from "@/assets/elektriker-schaltschrank.png";
import referenzAsset from "@/assets/einfamilienhaus-referenz-komplettsystem.png";
import gewerbeInteressierenAsset from "@/assets/gewerbe-interessieren.png";
import heroBgAsset from "@/assets/einfamilienhaus-hero-bg.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function Einfamilienhaus() {
  return (
    <>
      <Seo
        title="Für Ihr Einfamilienhaus | Zweering Elektrotechnik Emmerich am Rhein"
        description="Komplettes Energiesystem für Ihr Einfamilienhaus — Photovoltaik, Speicher, Wallbox und Smart-Home aus einer Hand in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/einfamilienhaus"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Für wen", "url": "https://zweering.de/einfamilienhaus"}, {"name": "Einfamilienhaus", "url": "https://zweering.de/einfamilienhaus"}]}
      />
      <LeistungsseiteTemplate
      label="FÜR WEN"
      title="FÜR IHR EINFAMILIENHAUS"
      subline="Unabhängiger werden, Kosten senken, zukunftssicher wohnen — Ihr komplettes Energiesystem aus einer Hand in Emmerich am Rhein und Umgebung."
      heroImage={heroBgAsset}
      heroImageAlt="Einfamilienhaus mit Photovoltaik-Anlage und gepflastertem Einfahrtsbereich"
      leadText={
        <>
          Ihr eigenes Dach, Ihr eigener Strom, Ihre eigene Entscheidung. Wir bringen
          Photovoltaik, Speicher, Wallbox und Steuerung zu einem System zusammen, das{" "}
          <span style={{ color: "#4CAF50" }}>zu Ihrem Zuhause passt</span> — und mit Ihnen
          wächst.
        </>
      }
      panels={[
        {
          title: "STROM SELBST ERZEUGEN",
          body: "Photovoltaik auf Ihrem Dach — die Basis Ihrer Unabhängigkeit.",
          ctaLabel: "Zur Photovoltaik →",
          ctaHref: "/photovoltaik",
          image: pvDachAsset,
          imageAlt: "Photovoltaik-Anlage auf einem Einfamilienhaus-Dach in Emmerich am Rhein",
        },
        {
          title: (
            <>
              STROM <span style={{ color: "#4CAF50" }}>SPEICHERN</span>
            </>
          ),
          body: "Ein Speicher macht Ihren Solarstrom rund um die Uhr nutzbar.",
          ctaLabel: "Zum Stromspeicher →",
          ctaHref: "/stromspeicher",
          image: stromspeicherAsset,
          imageAlt: "Stromspeicher und Wechselrichter an einer Wand im Hauswirtschaftsraum",
        },
        {
          title: "E-AUTO LADEN",
          body: "Ihre eigene Wallbox lädt mit eigenem Sonnenstrom.",
          ctaLabel: "Zur Wallbox →",
          ctaHref: "/wallbox",
          image: eAutoLadenAsset,
          imageAlt: "Wallbox an einer Garagenwand mit schwarzem E-Auto im Hintergrund",
        },
        {
          title: "INTELLIGENT STEUERN",
          body: "Smart Home und G2 verbinden alles zu einem System, das mitdenkt.",
          ctaLabel: "Zu Smart Home →",
          ctaHref: "/smart-home",
          image: smartHomeAsset,
          imageAlt: "Elektriker arbeitet am Schaltschrank im Einfamilienhaus",
        },
      ]}
      testimonials={allTestimonials}
      manifest={<>
        IHR DACH.
        <br />
        IHRE ENERGIE.
        <br />
        IHRE FREIHEIT.
      </>}
      caseStudy={{
        title: "KOMPLETTSYSTEM EINFAMILIENHAUS",
        text: "PV, Speicher und Wallbox — geplant, installiert und betreut aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "/referenzen",
        linkLabel: "Mehr Referenzen",
        image: referenzAsset,
        imageAlt: "Elektriker arbeitet an einem geöffneten Schaltschrank an einer Backsteinwand",
      }}
      extraSection={<HandwerkBento />}
      faq={[
        {
          frage: "Wo fange ich an?",
          antwort:
            "Meist mit der Photovoltaik-Anlage als Basis. Wir beraten Sie und planen erweiterbar.",
        },
        {
          frage: "Bekomme ich alles aus einer Hand?",
          antwort:
            "Ja — Planung, Installation und Betreuung aus einem Haus, ein Ansprechpartner.",
        },
        {
          frage: "Muss ich alles sofort machen?",
          antwort:
            "Nein. Sie können Schritt für Schritt erweitern, ohne alles neu zu machen.",
        },
        {
          frage: "Lohnt sich das am Niederrhein?",
          antwort:
            "Ja. Mit hohem Eigenverbrauch rechnet sich ein gut geplantes System auch in Emmerich am Rhein und Umgebung.",
        },
      ]}
      ctaText={{
        headline: "BEREIT FÜR IHR EIGENES ENERGIESYSTEM?",
        subtext: "Kostenlose Erstberatung für Ihr Eigenheim.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "FÜR GEWERBE",
        text: "Sie planen für einen Betrieb?",
        href: "/gewerbe",
        image: gewerbeInteressierenAsset,
        imageAlt: "Großes Gewerbegebäude mit ausgedehnter Photovoltaik-Anlage auf dem Flachdach",
      }}
    />
    </>
  );
}
